import { Button, Stack, Typography } from "@mui/material";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import StyledBanner from "../../components/commoncomponents/StyledBanner";
import WelcomeCard from "../../components/commoncomponents/WelcomeCard";
import { useLocation, useNavigate } from "react-router-dom";
import UserRepository from "../../api/repositories/userRepository";
import { getAuthToken, getcompanyId, setAuthToken } from "../../utility/tokenUtility";
import { encryptionKey } from "../../utility/secretKeys";
import CryptoJS from "crypto-js";
import axios from "axios";
import { MasterGraph } from "../../utility/apiURLS";


const VendorLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [decryptData, setDecryptData] = useState({});

     const decrypt = async (key, content) => {
        try {
          // Ensure the key is exactly 32 bytes (256 bits) for AES-256
          let keyBytes = CryptoJS.enc.Utf8.parse(key);
          let keyWords = keyBytes.words.slice(0, 8);  // AES-256 uses 8 words (32 bytes)
          let truncatedKey = CryptoJS.lib.WordArray.create(keyWords, 32);
    
          // Convert base64-encoded content back to bytes
          let encryptedBytes = CryptoJS.enc.Base64.parse(content);
    
          // Extract IV from the beginning of the encrypted data
          let iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
    
          // Extract the actual encrypted data
          let encryptedData = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4), encryptedBytes.sigBytes - 16);
    
          // Decrypt the data
          let decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedData },
            truncatedKey,
            {
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
            }
          );
    
          return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
          // Handle exceptions related to decryption
          console.error('Decryption error:', error.message);
          throw error;
        }
      };

        const getToken = async () => {
          try {
            const encodedToken = location.search.replace('token=', '');
            const cleanToken = encodedToken.startsWith('?') ? encodedToken.replace('?', '') : encodedToken;
            const decryptedContent = await decrypt(encryptionKey, cleanToken);
            const parsedData = JSON.parse(decryptedContent);
            setDecryptData(parsedData)
          } catch (error) {
            console.error(error.message);
          }
        };

    const autoTokenGenerate = async (data) => {
        const response = await UserRepository.validateUser(data);
        if (response.status === 200) {
            setAuthToken(response?.data?.idToken);
        }
    };

    useEffect(()=>{
        autoTokenGenerate({
            username:"superadmin",
            password:"Welcome@123"
        });
        getToken();
        
    },[]);
console.log(decryptData,"decryptadta");

    return (
        <StyledBanner>
            <WelcomeCard>
                <Box textAlign={"center"}>
                    <Typography variant="h2" color={"text.secondary"}>
                        Welcome {"SNQ Enterprise"}
                    </Typography>
                </Box>
                <Stack alignItems={"center"} gap={2}>

                    <Typography fontSize={14}>Don't have an account? Please Register</Typography>
                    <Button variant="contained" sx={{ width: "50%" }}
                        onClick={() => navigate("/vendorRegistration", {
                            state: {
                                companyId: decryptData?.CompanyId || "",
                                vendorId: decryptData?.VendorId || "",
                                vendorName: decryptData?.VendorName || ""
                            },
                        })}>
                        Register & Proceed
                    </Button>

                    <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"center"}>
                        <Typography fontSize={14}>Already have login? Click here to login.</Typography>
                        <Button variant="contained" onClick={() => navigate("/login")} >
                            Login
                        </Button>
                    </Stack>

                </Stack>
            </WelcomeCard>
        </StyledBanner>
    );
};

export default VendorLogin;
